export default "/assets/images/overreactor-hero-image.0a451ba5c8285024.png";